import { InputValidationGroup } from './types'
import { validateField } from './rules'

export const validateLogicalGroup = (
  group: InputValidationGroup,
  fields: Record<string, any>
): boolean => {
  if (Array.isArray(group.fields)) {
    if (group.type === 'AND') {
      return group.fields.every((field: string | InputValidationGroup) => {
        if (typeof field === 'string') {
          const fieldRules = fields[field]?.rules || []
          return validateField(field, fieldRules)
        }
        return validateLogicalGroup(field, fields)
      })
    } else if (group.type === 'OR') {
      return group.fields.some((field: string | InputValidationGroup) => {
        if (typeof field === 'string') {
          const fieldRules = fields[field]?.rules || []
          return validateField(field, fieldRules)
        }
        return validateLogicalGroup(field, fields)
      })
    }
  }
  return false
}
